import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TextKeys} from '../../core/i18n/text-keys';
import {UntypedFormControl} from '@angular/forms';
import * as moment from 'moment';
import {TIMEZONE} from '../../core/services/language.service';
import {Moment} from 'moment';
import {SessionQuery} from '../../core/state-mangement/session/session.query';

@Component({
  selector: 'app-create-visum',
  templateUrl: './create-visum.component.html',
  styleUrls: ['./create-visum.component.scss'],
})
export class CreateVisumComponent implements OnInit {
  @Output() cancelEvent = new EventEmitter();
  @Output() createVisumEvent = new EventEmitter<string>();
  @Input() selectedDate: string;

  date = new UntypedFormControl(moment.tz(moment(), TIMEZONE));
  time = new UntypedFormControl(moment.tz(moment(), TIMEZONE));
  texts = TextKeys;

  visumWithTime$ = this.sessionQuery.visumWithTime$;

  originalTime: Moment;
  fullDay = false;

  constructor(private sessionQuery: SessionQuery) {}

  ngOnInit() {
    const originalTime = moment
      .tz(this.selectedDate, TIMEZONE)
      .format('HH:mm:ss');
    const dateInTimeZone = moment.tz(this.selectedDate, TIMEZONE);

    const newDate = dateInTimeZone.format('YYYY-MM-DD');
    const combinedDateTime = moment.tz(`${newDate}T${originalTime}`, TIMEZONE);

    if (
      combinedDateTime.format('HH:mm') === '00:00' ||
      !this.sessionQuery.getValue()?.visumWithTime
    ) {
      this.time.setValue(
        combinedDateTime
          .set({ hour: 23, minute: 59, second: 59 })
          .format('HH:mm')
      );
      this.fullDay = true;
    } else {
      this.time.setValue(combinedDateTime.format('HH:mm'));
      this.fullDay = false;
    }
    this.date.setValue(combinedDateTime);
    this.originalTime = combinedDateTime;
  }

  emitCancelEvent() {
    this.cancelEvent.emit();
  }

  setVisum() {
    const selectedDate = this.date.value;
    const selectedTime = this.time.value;
    const combined = moment.tz(
      `${selectedDate.format('YYYY-MM-DD')}T${selectedTime}`,
      TIMEZONE
    );
    combined.seconds(59);
    this.createVisumEvent.emit(combined.format());
  }

  updateAllComplete() {
    const selectedDate = this.date.value as Date;
    const selectedTime = this.time.value as string;

    if (!selectedDate || !selectedTime) {
      console.warn('Date or Time is missing.');
      return;
    }

    const timeMoment = moment.tz(selectedTime, 'HH:mm', TIMEZONE);

    const selectedDateTime = moment.tz(selectedDate, TIMEZONE).set({
      hour: timeMoment.hour(),
      minute: timeMoment.minute(),
    });

    const endOfDay = selectedDateTime
      .clone()
      .set({ hour: 23, minute: 59, second: 59 });
    this.time.setValue(endOfDay.format('HH:mm'));
  }
}
